import PropTypes from 'prop-types';
import i18n from 'src/utils/translate';

const SurveyHeader = ({ onBack = () => {}, hideBack = false, hideClose = false, onClose = () => {} }) => {
  return (
    <div className="survey__header">
      {!hideBack ? (
        <div className="survey__header-left" onClick={onBack}>
          <span className="icon icon-left-open" /> {i18n.t('Back')}
        </div>
      ) : (
        <div>{' '}</div>
      )}
      {!hideClose &&
        <div className="survey__header-right" onClick={onClose}>
          {i18n.t('Close')} <span className="icon icon-cross-2" />
        </div>
      }
    </div>
  );
};

SurveyHeader.propTypes = {
  hideBack: PropTypes.bool,
  hideClose: PropTypes.bool,
  onBack: PropTypes.func,
  onClose: PropTypes.func,
};

export default SurveyHeader;
